// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zhLCU","requiredAsterisk":"Info_requiredAsterisk__3RCJJ"};